import { Component, HostBinding, Input } from '@angular/core';

import IAllowedUse = ZoneIQCalibration.IAllowedUse;
import { TableFieldOption, TableType } from 'src/shared/enums';
import { IBaseMutableModel } from 'src/app/interfaces/base-mutable-model.interface';
import { IAttributesIdentifiers } from 'src/app/interfaces/attributes-identifiers.interface';
import { BaseFieldComponent } from 'src/app/components/fields/base-field.component';

@Component({
    standalone: false,
    selector: 'ziq-use-allowance-select',
    templateUrl: './ziq-use-allowance-select.component.html',
    styleUrls: ['./ziq-use-allowance-select.component.scss']
})
export class ZIQUseAllowanceSelectComponent extends BaseFieldComponent {
    @Input()
    use: IBaseMutableModel<any>;

    @Input()
    useAllowances: IAllowedUse[];

    @Input()
    currentTab: string;

    @Input()
    attributePopupTitleDetails?: string;

    @Input()
    hideAttributeButtons: boolean = false;

    @Input()
    readOnly: boolean = false;

    @HostBinding('class')
    readonly hostClass = 'ziq-use-allowance-select';

    identifier: IAttributesIdentifiers;

    handleManualChange() {
        this.use.markManuallyChangedProperty('AllowedUsesId');
    }

    handleValueChange() {
        if (this.use.getIsOriginalState('AllowedUsesId')) {
            return;
        }
        this.syncService.emitValueChanged(this);
    }

    ngOnInit() {
        this.identifier = {
            calibrationSetId:
                this.use.currentState.ZoneCombinationId ||
                this.use.currentState.OverlayTypologyId ||
                this.use.currentState.OverlayId,
            calibrationSetType: this.calibrationSetType,
            tableType: TableType.CALIBRATION_USES,
            tableFieldOption: TableFieldOption.USE_ALLOWANCE,
            tableField: { Id: this.use.currentState.CalibrationUsesLabelId }
        };
    }
}
